/**
 * Created by Jerker Nord on 2023-10-17.
 */
import {Loner} from "../../../../Loner";
import {PixelFont} from "../../../../fonts/PixelFont";
import {NLCText} from "@nolimitcity/slot-launcher/bin/display/NLCText";

export class LonerEndCreditContainer extends PIXI.Container {

    private static NAME_SPACING:number = 5;
    private static LINE_SPACING:number = 4;

    private _firstName:NLCText;
    private _lastName:NLCText;
    private _role:NLCText;
    private _nameContainer:PIXI.Container;

    constructor() {
        super();
        this.init();
    }

    private init():void {
        this._nameContainer = new PIXI.Container();
        this.addChild(this._nameContainer);

        this._role = new NLCText(Loner.apiPlugin.translations.translate(""), new PIXI.TextStyle({
            fontFamily : PixelFont.FAMILY,
            fontSize : 20,
            fill : 0xE0E0E0
        }));
        this.addChild(this._role);

        this._firstName = new NLCText(Loner.apiPlugin.translations.translate(""), new PIXI.TextStyle({
            fontFamily : PixelFont.FAMILY,
            fontSize : 16,
            fill : 0xE0E0E0
        }));
        this._nameContainer.addChild(this._firstName);

        this._lastName = new NLCText(Loner.apiPlugin.translations.translate(""), new PIXI.TextStyle({
            fontFamily : PixelFont.FAMILY,
            fontSize : 16,
            fill : 0xE0E0E0
        }));
        this._nameContainer.addChild(this._lastName);
    }

    public sort():void {
        this._lastName.position.x = this._firstName.width + LonerEndCreditContainer.NAME_SPACING;
        this._nameContainer.position.y = this._role.height + LonerEndCreditContainer.LINE_SPACING;
        this._role.position.x = 0;
        this._nameContainer.position.x = 0;
        this._firstName.updateTransform();
        this._lastName.updateTransform();
        this._nameContainer.updateTransform();
        this._role.updateTransform();
        if (this._role.width > this._nameContainer.width){
            this._role.position.x = (this.width / 2) - (this._role.width / 2);
            this._nameContainer.position.x = this._role.position.x + (this._role.width/2) - (this._nameContainer.width/2);
        }else{
            this._nameContainer.position.x = (this.width / 2) - (this._nameContainer.width / 2);
            this._role.position.x = this._nameContainer.position.x + (this._nameContainer.width/2) - (this._role.width/2);
        }
        this.position.x = 160 - (this.width/2);
    }

    set firstName(value:string) {
        this._firstName.text = value;
    }

    set lastName(value:string) {
        this._lastName.text = value;
    }

    set role(value:string) {
        this._role.text = value;
    }
}